import React, { useState } from 'react';
import { inviteMember, cancelInvite } from '../../services/groupService';

const GroupInviteSection = ({ members, subscription, pendingInvites, onUpdate }) => {
  const [inviteEmail, setInviteEmail] = useState('');
  const [inviteMsg, setInviteMsg] = useState('');
  const [inviteErr, setInviteErr] = useState('');
  const [sending, setSending] = useState(false);

  const maxMembers = subscription?.max_members ?? 5;
  const memberCount = members.length;
  const atLimit = memberCount >= maxMembers;

  const handleInvite = async (e) => {
    e.preventDefault();
    setInviteMsg('');
    setInviteErr('');

    if (!inviteEmail.trim()) {
      setInviteErr('Please enter an email address');
      return;
    }

    setSending(true);
    try {
      const data = await inviteMember(inviteEmail.trim());
      setInviteMsg(data.message);
      setInviteEmail('');
      onUpdate();
    } catch (err) {
      setInviteErr(err.response?.data?.message || 'Failed to send invite');
    } finally {
      setSending(false);
    }
  };

  const handleCancelInvite = async (inviteId, email) => {
    if (!window.confirm(`Cancel the invite to ${email}?`)) return;
    try {
      await cancelInvite(inviteId);
      onUpdate();
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to cancel invite');
    }
  };

  return (
    <div style={styles.card}>
      <h3 style={styles.sectionTitle}>Invite a Member</h3>
      {atLimit ? (
        <p style={styles.limitMsg}>
          You've reached your plan's limit of {maxMembers} members. Upgrade to invite more.
        </p>
      ) : (
        <form onSubmit={handleInvite} style={styles.inviteForm}>
          <input
            type="email"
            placeholder="friend@example.com"
            value={inviteEmail}
            onChange={(e) => setInviteEmail(e.target.value)}
            style={styles.input}
            disabled={sending}
          />
          <button type="submit" style={styles.inviteBtn} disabled={sending}>
            {sending ? 'Sending...' : 'Send Invite'}
          </button>
        </form>
      )}
      {inviteMsg && <p style={styles.successMsg}>{inviteMsg}</p>}
      {inviteErr && <p style={styles.errorMsg}>{inviteErr}</p>}

      {pendingInvites?.length > 0 && (
        <div style={styles.pendingList}>
          <p style={styles.pendingLabel}>Pending invites:</p>
          {pendingInvites.map((inv) => (
            <span key={inv.id} style={styles.pendingItem}>
              {inv.email}
              <button
                onClick={() => handleCancelInvite(inv.id, inv.email)}
                style={styles.cancelInviteBtn}
                title="Cancel invite"
              >
                ✕
              </button>
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  card: {
    backgroundColor: 'white',
    padding: '32px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    marginBottom: '24px',
  },
  sectionTitle: {
    color: '#333',
    fontSize: '16px',
    marginBottom: '10px',
  },
  inviteForm: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap',
  },
  input: {
    flex: 1,
    minWidth: '200px',
    padding: '10px 14px',
    borderRadius: '8px',
    border: '1px solid #ddd',
    fontSize: '14px',
  },
  inviteBtn: {
    padding: '10px 20px',
    backgroundColor: '#e67e22',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
  successMsg: {
    color: '#27ae60',
    fontSize: '13px',
    marginTop: '10px',
  },
  errorMsg: {
    color: '#e74c3c',
    fontSize: '13px',
    marginTop: '10px',
  },
  limitMsg: {
    color: '#e67e22',
    fontSize: '14px',
  },
  pendingList: {
    marginTop: '14px',
  },
  pendingLabel: {
    color: '#999',
    fontSize: '12px',
    marginBottom: '6px',
  },
  pendingItem: {
    display: 'inline-block',
    backgroundColor: '#f5f5f5',
    color: '#666',
    padding: '4px 10px',
    borderRadius: '6px',
    fontSize: '12px',
    marginRight: '6px',
    marginBottom: '6px',
  },
  cancelInviteBtn: {
    marginLeft: '8px',
    padding: '0 4px',
    backgroundColor: 'transparent',
    color: '#e74c3c',
    border: 'none',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '700',
  },
};

export default GroupInviteSection;
